import { useCallback, useEffect } from "react";

import useGroupContext from "pages/[tenant]/g/hooks/useGroupContext";

const useCheckImageCover = () => {
  const {
    group,
    failedToLoadImgBanner,
    setScrollBarIsOnTop,
    setFailedToLoadImgBanner,
  } = useGroupContext();

  const noImage =
    failedToLoadImgBanner === true || group?.banner_address === null;

  const checkImageCover = useCallback(() => {
    if (noImage) {
      setScrollBarIsOnTop(true);
      setFailedToLoadImgBanner(true);
    }
  }, [noImage, setFailedToLoadImgBanner, setScrollBarIsOnTop]);

  useEffect(() => {
    checkImageCover();
  }, [checkImageCover]);

  return {};
};

export default useCheckImageCover;
